/**
 * Return a new array with duplicate entries removed, keyed by a
 * caller-supplied key function. First-seen order is preserved.
 * O(n) time, O(n) memory.
 *
 * Used by the storefront's infinite-query hook (F-005 §5.3 + §17 M2) to
 * survive concurrent-insert pagination races — if a product is inserted
 * between two consecutive page fetches, offset-based pagination can
 * return the same row on two pages. React's `key={product.id}` would
 * log a warning; this helper collapses the duplicate at the hook
 * boundary before render.
 */
export function dedupeBy<T, K>(items: readonly T[], key: (item: T) => K): T[] {
  const seen = new Set<K>();
  const out: T[] = [];
  for (const item of items) {
    const k = key(item);
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(item);
  }
  return out;
}
